import { keyframes } from '@emotion/react';

const pulse = keyframes`
to {
  box-shadow: 0 0 0 18px rgba(255, 255, 255, 0); 
}
`;

export default pulse;
